import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { GraduationCap, BookOpen, UserPlus, Calendar } from 'lucide-react';
import ClassManagement from '../components/settings/ClassManagement';
import SubjectManagement from '../components/settings/SubjectManagement';
import RegistrationSettings from '../components/settings/RegistrationSettings';
import AcademicYearSettings from '../components/settings/AcademicYearSettings';

const tabs = [
  {
    path: 'classes',
    label: 'Classes & Sections',
    icon: GraduationCap,
    description: 'Manage school classes and their sections'
  },
  {
    path: 'subjects',
    label: 'Subjects',
    icon: BookOpen,
    description: 'Manage curriculum and subjects'
  },
  {
    path: 'registration',
    label: 'Registration Settings',
    icon: UserPlus,
    description: 'Configure student registration options'
  },
  {
    path: 'academic-year',
    label: 'Academic Year',
    icon: Calendar,
    description: 'Set the current school-wide session'
  }
];

const Settings: React.FC = () => {
  const location = useLocation();
  const current = tabs.find(tab => location.pathname.endsWith(`/settings/${tab.path}`)) || tabs[0];
  const Icon = current.icon;

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center space-x-3">
        <div className="w-8 h-8 bg-[#e2916d] rounded-lg flex items-center justify-center">
          <Icon className="w-5 h-5 text-white" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-[#f3ede2]">{current.label}</h1>
          <p className="text-[#b9ad9b] mt-1">{current.description}</p>
        </div>
      </div>

      <div className="bg-[#211c15] rounded-xl border border-[#3a3122] p-6">
        <Routes>
          <Route index element={<Navigate to="classes" replace />} />
          <Route path="classes" element={<ClassManagement />} />
          <Route path="subjects" element={<SubjectManagement />} />
          <Route path="registration" element={<RegistrationSettings />} />
          <Route path="academic-year" element={<AcademicYearSettings />} />
          <Route path="*" element={<Navigate to="classes" replace />} />
        </Routes>
      </div>
    </div>
  );
};

export default Settings;
